import { SxProps, Theme } from '@mui/material/styles'
import { hoverBaseStyles } from '../base/hoverBase.styles'

export const suspendedStyles = {
  root: {
    ...hoverBaseStyles.root,
  } as SxProps<Theme>,

  reason: {
    color: 'gray.80',
    ...hoverBaseStyles.textRegular,
  } as SxProps<Theme>,
}
